import { VStack } from "goi_common";

import ParlorItem from "./ParlorItem";

function ParlorListTabPanel({
  name,
  parlors,
  serviceName,
  expectedParlorPrice,
  sido,
  sigungu,
}: {
  parlors: any;
  serviceName?: string;
  name: string;
  expectedParlorPrice: number;
  sido: string;
  sigungu?: string;
}) {
  return (
    <VStack gap={16} padding="10px 18px 80px" className="body_14_m" width="100%">
      {parlors?.map((p: any, i: number) => (
        <>
          <ParlorItem
            key={p.companyname + "_" + p.id}
            id={p.id}
            sido={p.sido}
            src={p.images.length > 0 ? p.images[0].url : undefined}
            name={p.companyname}
            address={p.address}
            serviceName={serviceName}
            price={
              serviceName
                ? p.expected_charge_sum[
                    serviceName === "무빈소장례"
                      ? "무빈소"
                      : (serviceName as "무빈소" | "가족장" | "일반장")
                  ]
                : p.binso_average_charge
            }
            type={p.type}
            description={p.percentage ? `평균보다 ${p.percentage}% 저렴해요` : ""}
          />
        </>
      ))}
      {parlors.length === 0 && "이 지역에 주소를 둔 장례식장이 검색되지 않았습니다."}
    </VStack>
  );
}
export default ParlorListTabPanel;
